// # Questions section component for profile
import React from 'react';
import './prfl_quest.css';

const ProfileQuestions = ({ isDarkMode }) => {
  return (
    <div className={`prfl_quest_container ${isDarkMode ? 'prfl_dark-mode' : ''}`}>
      <div className="prfl_quest_coming-soon">
        <h3>Questions Feature Coming Soon</h3>
        <p>Ask and answer medical questions, share knowledge with peers.</p>
      </div>
    </div>
  );
};

export default ProfileQuestions;
